'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIcecream = function IoIcecream(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 20h20l-10 17.5z m21.5-6.5c0.6 0.4 1 1 1 1.8 0 1.3-1.1 2.2-2.3 2.2h-20.4c-1.2 0-2.3-1-2.3-2.2 0-0.8 0.5-1.4 1.1-1.8 0.1 0 0.1-0.1 0.1-0.1 0.4-0.3 0.6-0.6 0.7-1v-0.1c-0.2-0.4-0.2-0.9-0.2-1.4 0-3.2 2.7-5.9 6-5.9 0.6 0 1.2 0.2 1.8 0.3-0.3 1-0.4 2.4-0.4 2.4 0.2-1.1 0.9-2.2 0.9-2.2 1.4-1.8 3.6-3 6-3 4.2 0 7.5 3.4 7.5 7.5 0 0.9-0.1 1.6-0.4 2.3v0.1c0 0.3 0.3 0.7 0.6 1 0.1 0 0.2 0.1 0.3 0.1z' })
        )
    );
};

exports.default = IoIcecream;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/icecream.js
// module id = 2530
// module chunks = 168707334958949